import notie from 'notie'

export default function notify (level = 'info', message, time = 2) {
  notie.alert(level, message, time)
}
